(() => {
  function autoSelectCondition() {
    document.querySelectorAll('variant-selects').forEach(variantSelects => {
      const fieldsets = [...variantSelects.querySelectorAll('fieldset')];
      let conditionFieldset = null;

      fieldsets.forEach(fs => {
        const legend = fs.querySelector('legend');
        if (legend && legend.textContent.trim() === 'Condition') {
          conditionFieldset = fs;
        }
      });

      if (!conditionFieldset) return;

      const checkedCondition = conditionFieldset.querySelector('input[type="radio"]:checked');
      if (checkedCondition) return;

      const firstInput = conditionFieldset.querySelector('input[type="radio"]');
      if (firstInput) {
        firstInput.checked = true;
        firstInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => setTimeout(autoSelectCondition, 100));

  document.addEventListener('click', (e) => {
    const fieldset = e.target.closest('fieldset');
    if (!fieldset) return;
    const legend = fieldset.querySelector('legend');
    if (legend && legend.textContent.trim() === 'Format') {
      setTimeout(autoSelectCondition, 400);
    }
  });
})();

